import { DefaultTheme } from 'styled-components';
import dark from './dark';
import light from './light';

export type ThemesTypes = {
  LIGHT: DefaultTheme;
  DARK: DefaultTheme;
};

const themes: ThemesTypes = {
  LIGHT: light as DefaultTheme,
  DARK: dark as DefaultTheme,
};

export default themes;
